import { Auth } from "@/helpers/Auth";
import { BaseSocket } from "@/store/modules/sockets/baseSocket";
import { checkEndUrlConfig } from "@/helpers/checkEndUrlConfig";
export class SystemEventsSocket extends BaseSocket {
    constructor(Socket, filter) {
        super(Socket);
        const filterReaders = filter ? `&filter=${filter}` : "";
        this.apiUrl = `${checkEndUrlConfig(Auth.getWebGatewayUriForSocket)}SystemEventsService?accessToken=${Auth.getToken}${filterReaders}`;
    }
}
